import { apiRequest} from './index'

export const getUnitsRequest = (filters) => {
    const {
      page=0,
      limit=0,
      project="",
      block_number="",
      lot_number="",
      status="",
      client=""
    } = filters;  
    
    return apiRequest(
      `/admin/units?page=${page}&limit=${limit}&project=${project}&block_number=${block_number}&lot_number=${lot_number}&status=${status}&client=${client}`,
      {
        method: 'GET'
      },
      true
    )
}

export const createUnitRequest = (unit) => {
    return apiRequest(
      `/admin/units`,
      {
        method: 'POST',
        body: JSON.stringify(unit)
      },
      true
    )
}

export const getUnitRequest = (id) => {
    return apiRequest(
      `/admin/units/${id}`,
      {
        method: 'GET'
      },
      true
    )
}

export const updateUnitRequest = (unit) => {
  return apiRequest(
    `/admin/units/${unit._id}`,
    {
            method: 'PUT',
            body: JSON.stringify(unit)
    },
    true
  )
}

export const markUnitAsReservedRequest = (data) => {
  return apiRequest(
    `/admin/units/mark-as-reserved/${data.unit._id}`,
    {
            method: 'POST',
            body: JSON.stringify(data)
    },
    true
  )
}

export const markUnitAsSoldRequest = (data) => {
  return apiRequest(
    `/admin/units/mark-as-sold/${data.unit._id}`,
    {
            method: 'POST',
            body: JSON.stringify(data)
    },
    true
  )
}
  
export const deleteUnitRequest = (id) => {
  return apiRequest(
    `/admin/units/${id}`,
    {
            method: 'DELETE'
    },
    true
  )
}

export const cancelUnitReservationRequest = (data) => {
  return apiRequest(
    `/admin/units/cancel-reservation/${data.unit._id}`,
    {
            method: 'POST',
            body: JSON.stringify(data)
    },
    true
  )
}

export const cancelUnitSaleRequest = (data) => {
  return apiRequest(
    `/admin/units/cancel-sale/${data.unit._id}`,
    {
            method: 'POST',
            body: JSON.stringify(data)
    },
    true
  )
}

export const getUnitBalanceRequest = (unitId) => {
  return apiRequest(
    `/admin/units/${unitId}/balance`,
    {
      method: 'GET'
    },
    true
  )
}

export const getUnitTotalPaidRequest = (unitId, year) => {
  return apiRequest(
    `/admin/units/${unitId}/total-paid${year ? `?year=${year}` : ''}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getUnitTotalCostRequest = (unitId, year, yearPaidPercentage) => {
  return apiRequest(
    `/admin/units/${unitId}/total-cost${year && yearPaidPercentage ? `?year=${year}&percentage=${yearPaidPercentage}` : ''}`,
    {
      method: 'GET'
    },
    true
  )
}

export const transferUnitRequest = (data) => {
  return apiRequest(
    `/admin/units/${data.unit._id}/transfer`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    },
    true
  )
}